export default "__VITE_ASSET__DYKFYHx9__"